import { SVGProps } from '../types';

const SheetFileIcon = (props: SVGProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.014 1.6908V4.6908H13.014" stroke="currentColor" />
      <path
        d="M8.01402 7.35742V9.35742M8.01402 9.35742V11.3574M8.01402 9.35742H5.01404M8.01402 9.35742H11.014M5.01404 11.3574H11.014V7.35742H5.01404V11.3574Z"
        stroke="currentColor"
        stroke-linejoin="round"
      />
      <path
        d="M2.66711 14.6219V1.34062C2.66711 1.33696 2.67009 1.33398 2.67377 1.33398H9.99337L13.333 4.68V14.6594C13.333 14.6631 13.33 14.666 13.3263 14.666L2.67375 14.6285C2.67008 14.6285 2.66711 14.6256 2.66711 14.6219Z"
        stroke="currentColor"
      />
    </svg>
  );
};

export { SheetFileIcon };
